var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upload-attachment" }, [
    _c("fieldset", { staticClass: "info-group" }, [
      _c("legend", [_vm._v(_vm._s(_vm.$t("kyc.section.uploadAttachment")))]),
    ]),
    _c("div", { staticClass: "info-group" }, [
      _c(
        "div",
        {
          staticClass: "form-group",
          class: {
            "has-error": _vm.certificateOfIncorporationStatus,
            valid: _vm.certificateOfIncorporationStatus,
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "control-label upload-label app-logo-label-kyc",
              attrs: { for: "CertificateOfIncorporation" },
            },
            [_vm._v("Certificate of Incorporation：")]
          ),
          _c(
            "div",
            { staticClass: "app-logo-wrapper-kyc" },
            [
              _c("vuestic-file-upload-kyc", {
                ref: "fieldInput",
                attrs: {
                  id: "CertificateOfIncorporation",
                  type: "list",
                  disabled: _vm.kycStatus === "submitted" ? true : false,
                },
                on: {
                  input: function ($event) {
                    return _vm.uploadFile(
                      arguments[0],
                      "certificateOfIncorporation"
                    )
                  },
                  removeFile: function ($event) {
                    return _vm.removeFile(
                      arguments[0],
                      "certificateOfIncorporation"
                    )
                  },
                },
                model: {
                  value: _vm.uploadAttachment.certificateOfIncorporation,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.uploadAttachment,
                      "certificateOfIncorporation",
                      $$v
                    )
                  },
                  expression: "uploadAttachment.certificateOfIncorporation",
                },
              }),
              _c(
                "small",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.certificateOfIncorporationStatus,
                      expression: "certificateOfIncorporationStatus",
                    },
                  ],
                  staticClass: "help text-danger",
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("kyc.theCertificateOfIncorporationFieldIsRequired")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
    _vm.isHK
      ? _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: {
                "has-error": _vm.businessRegistrationStatus,
                valid: _vm.businessRegistrationStatus,
              },
            },
            [
              _c(
                "label",
                {
                  staticClass: "control-label upload-label app-logo-label-kyc",
                  attrs: { for: "businessRegistration" },
                },
                [
                  _vm._v(_vm._s(_vm.$t("kyc.businessRegistration"))),
                  _c("br"),
                  _vm._v("(Mandatory for HK Company)："),
                ]
              ),
              _c(
                "div",
                { staticClass: "app-logo-wrapper-kyc" },
                [
                  _c("vuestic-file-upload-kyc", {
                    ref: "fieldInput",
                    attrs: {
                      id: "businessRegistration",
                      type: "list",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.uploadFile(
                          arguments[0],
                          "businessRegistration"
                        )
                      },
                      removeFile: function ($event) {
                        return _vm.removeFile(
                          arguments[0],
                          "businessRegistration"
                        )
                      },
                    },
                    model: {
                      value: _vm.uploadAttachment.businessRegistration,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.uploadAttachment,
                          "businessRegistration",
                          $$v
                        )
                      },
                      expression: "uploadAttachment.businessRegistration",
                    },
                  }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.businessRegistrationStatus,
                          expression: "businessRegistrationStatus",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("kyc.theBusinessRegistrationFieldIsRequired")
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm.isHK
      ? _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "has-error": _vm.nar1Status, valid: _vm.nar1Status },
            },
            [
              _c(
                "label",
                {
                  staticClass: "control-label upload-label app-logo-label-kyc",
                  attrs: { for: "nar1" },
                },
                [
                  _vm._v(_vm._s(_vm.$t("kyc.nar1"))),
                  _c("br"),
                  _vm._v("(Mandatory for HK Company)："),
                ]
              ),
              _c(
                "div",
                { staticClass: "app-logo-wrapper-kyc" },
                [
                  _c("vuestic-file-upload-kyc", {
                    ref: "fieldInput",
                    attrs: {
                      id: "nar1",
                      type: "list",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.uploadFile(arguments[0], "nar1")
                      },
                      removeFile: function ($event) {
                        return _vm.removeFile(arguments[0], "nar1")
                      },
                    },
                    model: {
                      value: _vm.uploadAttachment.nar1,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadAttachment, "nar1", $$v)
                      },
                      expression: "uploadAttachment.nar1",
                    },
                  }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.nar1Status,
                          expression: "nar1Status",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.$t("kyc.theNar1FieldIsRequired")))]
                  ),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "info-group" }, [
      _c(
        "div",
        {
          staticClass: "form-group",
          class: {
            "has-error": _vm.articlesOfAssociationStatus,
            valid: _vm.articlesOfAssociationStatus,
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "control-label upload-label app-logo-label-kyc",
              attrs: { for: "articlesOfAssociation" },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.kycStatus === "firstEdit"
                    ? "Articles of Association："
                    : "Memodumum & Articles of Association："
                )
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "app-logo-wrapper-kyc" },
            [
              _c("vuestic-file-upload-kyc", {
                ref: "fieldInput",
                attrs: {
                  id: "articlesOfAssociation",
                  type: "list",
                  disabled: _vm.kycStatus === "submitted" ? true : false,
                },
                on: {
                  input: function ($event) {
                    return _vm.uploadFile(arguments[0], "articlesOfAssociation")
                  },
                  removeFile: function ($event) {
                    return _vm.removeFile(arguments[0], "articlesOfAssociation")
                  },
                },
                model: {
                  value: _vm.uploadAttachment.articlesOfAssociation,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadAttachment, "articlesOfAssociation", $$v)
                  },
                  expression: "uploadAttachment.articlesOfAssociation",
                },
              }),
              _c(
                "small",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.articlesOfAssociationStatus,
                      expression: "articlesOfAssociationStatus",
                    },
                  ],
                  staticClass: "help text-danger",
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("kyc.theArticlesOfAssociationFieldIsRequired")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "info-group" }, [
      _c(
        "div",
        {
          staticClass: "form-group aml-question-group",
          class: {
            "has-error": _vm.amlQuestionnaireStatus,
            valid: _vm.amlQuestionnaireStatus,
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "control-label upload-label app-logo-label-kyc",
              attrs: { for: "amlQuestionnaire" },
            },
            [_vm._v("AML Questionnaire：")]
          ),
          _c(
            "div",
            { staticClass: "app-logo-wrapper-kyc" },
            [
              _c("vuestic-file-upload-kyc", {
                ref: "fieldInput",
                attrs: {
                  id: "amlQuestionnaire",
                  type: "list",
                  disabled: _vm.kycStatus === "submitted" ? true : false,
                },
                on: {
                  input: function ($event) {
                    return _vm.uploadFile(arguments[0], "amlQuestionnaire")
                  },
                  removeFile: function ($event) {
                    return _vm.removeFile(arguments[0], "amlQuestionnaire")
                  },
                },
                model: {
                  value: _vm.uploadAttachment.amlQuestionnaire,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadAttachment, "amlQuestionnaire", $$v)
                  },
                  expression: "uploadAttachment.amlQuestionnaire",
                },
              }),
              _c(
                "small",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.amlQuestionnaireStatus,
                      expression: "amlQuestionnaireStatus",
                    },
                  ],
                  staticClass: "help text-danger",
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("kyc.theAmlQuestionnaireFieldIsRequired"))
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-micro aml-question-btn",
                attrs: {
                  type: "button",
                  disabled: _vm.kycStatus === "submitted" ? true : false,
                },
                on: { click: _vm.downloadTemplate },
              },
              [
                _c("b-icon-download", { staticClass: "mr-1" }),
                _c("span", { staticClass: "align-middle" }, [
                  _vm._v(_vm._s(_vm.$t("basic.button.template"))),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }